import { render, staticRenderFns } from "./attorney-received-disclosures.vue?vue&type=template&id=82c4cb6e"
import script from "./attorney-received-disclosures.vue?vue&type=script&lang=js"
export * from "./attorney-received-disclosures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports